import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const utahData = "/img/headerlogo.png";
const bodex = "/img/bodexLogo.png";
const kpi = "/img/KPI-DASH 2.png";
const pdf = "/img/pdf1.png";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const TransportationTable8 = ({ data }) => {
  const pdfRef = useRef();

  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  const industries = data.filter((x) => x.emp_count != 0).map((d) => d.industry_label);
  const counts = data.map((d) => parseInt(d.emp_count || 0));

  const chartData = {
    labels: industries,
    datasets: [
      {
        label: "Employment Count",
        data: counts,
        backgroundColor: "rgba(54, 162, 235, 0.7)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y", // horizontal bar chart
    responsive: true,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: "Employment by Age Group (14-18)",
      },
    },
    scales: {
      x: {
        title: { display: true, text: "Employment Count" },
        beginAtZero: true,
      },
      y: { title: { display: true, text: "Industry" } },
    },
  };

  const downloadPDF = () => {
    const input = pdfRef.current;
    const originalWidth = input.style.width;
    input.style.width = "1200px";

    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdfDoc = new jsPDF("l", "mm", "a4"); // landscape for long labels

      const imgWidth = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Header
      pdfDoc.addImage(utahData, "PNG", 20, 10, 32, 16);
      pdfDoc.setFontSize(20);
      pdfDoc.text("UTahData.org", 60, 20);
      pdfDoc.link(20, 10, 60, 10, { url: "https://utahdata.org" });
      pdfDoc.line(10, 30, 287, 30);

      // Main chart
      const headerHeight = 35;
      pdfDoc.addImage(
        imgData,
        "PNG",
        10,
        headerHeight,
        imgWidth - 20,
        imgHeight
      );

      // Footer
      pdfDoc.line(10, 190, 287, 190);
      const footerY = 195;
      pdfDoc.addImage(utahData, "PNG", 22, footerY, 30, 15);
      pdfDoc.setFontSize(10);
      pdfDoc.text("Built by", 60, footerY + 10);
      pdfDoc.addImage(bodex, "PNG", 75, footerY + 4, 44, 10);
      pdfDoc.text("using", 125, footerY + 10);
      pdfDoc.addImage(kpi, "PNG", 140, footerY, 20, 20);
      pdfDoc.text(" 20250916.v3.198", 165, footerY + 10);

      const currentDate = new Date().toLocaleDateString();
      pdfDoc.text(`Downloaded on: ${currentDate}`, 200, 210);
      pdfDoc.text(`Downloaded from: ${window.location.href}`, 10, 210);

      pdfDoc.save("industry-employment.pdf");
      input.style.width = originalWidth;
    });
  };

  return (
    <>
      <div ref={pdfRef} className="content-to-export">
        <div style={{ padding: "20px" }}>
          <h2>Employment by Age Group (14-18)</h2>
          <div className="overflow-x-auto">
            <table className="table table-striped bg-white">
              <thead>
                <tr>
                  <th>Industry</th>
                  <th>Employment Count</th>
                </tr>
              </thead>
              <tbody>
                {data
                  .filter((x) => x.emp_count != 0)
                  .map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.industry_label}</td>
                      <td>{row.emp_count}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Chart */}
        <div
          style={{
            width: "95%",
            maxWidth: "1000px",
            margin: "auto",
            background: "#fff",
          }}
        >
          <Bar data={chartData} options={options} />
        </div>
      </div>

      {/* Download PDF Button */}
      <br />
      <div className="flex justify-center">
        <button
          onClick={downloadPDF}
          className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
        >
          <span>Download as PDF </span>
          <span>
            <img className="w-[2rem]" src={pdf} alt="pdf-icon" />
          </span>
        </button>
      </div>
    </>
  );
};

export default TransportationTable8;
